export default import.meta.ROLLDOWN_FILE_URL_m8R6TgWxwop2r_xOIPNRtg